import React, { useEffect, useState } from 'react';
import loadGtag from '@/lib/analytics';

const CONSENT_KEY = 'analytics_consent_v1';

export default function CookieConsent(){
  const [visible, setVisible] = useState(false);

  useEffect(()=>{
    try{
      const existing = localStorage.getItem(CONSENT_KEY);
      if(!existing){
        setVisible(true);
      } else if(existing === 'granted'){
        loadGtag();
      }
    }catch(e){
      // ignore storage errors
    }
  },[]);

  const accept = () => {
    try{ localStorage.setItem(CONSENT_KEY, 'granted'); }catch(e){ /* ignore */ }
    loadGtag();
    setVisible(false);
  };

  const decline = () => {
    try{ localStorage.setItem(CONSENT_KEY, 'denied'); }catch(e){ /* ignore */ }
    setVisible(false);
  };

  if(!visible) return null;

  return (
    <div role="dialog" aria-label="موافقة ملفات تعريف الارتباط" style={{position:'fixed',right:18,bottom:18,zIndex:9999,maxWidth:520,background:'#fff',borderRadius:8,padding:12,boxShadow:'0 6px 24px rgba(0,0,0,0.12)'}}>
      <div style={{fontSize:14,marginBottom:8}}>نستخدم ملفات تعريف الارتباط لتحسين الأداء وتحليلات الزوار. هل تسمح بتحميل أدوات التحليل؟</div>
      <div style={{display:'flex',gap:8,justifyContent:'flex-end'}}>
        <button onClick={decline} aria-label="رفض تحليلات" style={{padding:'8px 12px',background:'#eee',borderRadius:6,border:'none'}}>رفض</button>
        <button onClick={accept} aria-label="موافق على التحليلات" style={{padding:'8px 12px',background:'#065f5b',color:'#fff',borderRadius:6,border:'none',fontWeight:700}}>موافق</button>
      </div>
    </div>
  );
}
